import { useMemo } from 'react';
import { standardizeLocale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

export type ComparatorType = (x: string, y: string) => number;

export const useLocaleCompare = (): ComparatorType => {
	const { locale } = useTenantContext();
	return useMemo(() => {
		const collator = new Intl.Collator(standardizeLocale(locale), { sensitivity: 'base' });
		return collator.compare;
	}, [locale]);
};
